export default {
  namespaced: true,

  state: { windowInnerWidth: null },

  getters: {
    xxl: (state) => state.windowInnerWidth >= 1600,
    isHorizontalLabel: (state) => state.windowInnerWidth >= 1600,
    isSmAndDown: (state) => state.windowInnerWidth < 960,
    isXs: (state) => state.windowInnerWidth < 620
  },

  mutations: {
    setWindowInnerWidth(state, payload) {
      state.windowInnerWidth = payload
    }
  },

  actions: {
    addWindowWidthEventListener({ commit }) {
      commit('setWindowInnerWidth', window.innerWidth)
      window.addEventListener('resize', () => commit('setWindowInnerWidth', window.innerWidth))
    },

    removeWindowWidthEventListener({ commit }) {
      commit('setWindowInnerWidth', null)
      window.removeEventListener('resize', () => commit('setWindowInnerWidth', window.innerWidth))
    }
  }
}
